import { DEFAULT_OG_IMAGE } from '@dupe/common/constants'

export const description =
  "Save up to 90 % on designer furniture and home decor with Dupe.com's visual search—compare prices instantly and discover dupes from thousands of stores."
export const defaultTitle = `Dupe.com | #1 Visual Dupe Finder`

const config = {
  defaultTitle,
  titleTemplate: '%s | Dupe.com',
  description,
  openGraph: {
    title: defaultTitle,
    description: description,
    type: 'website',
    site_name: 'Dupe.com',
    images: [
      {
        url: DEFAULT_OG_IMAGE,
      },
    ],
  },
  twitter: {
    handle: '@dupedotcom',
    site: '@dupedotcom',
    cardType: 'summary_large_image',
  },
}

export default config
